<template>
  <div
    class="input-wrapper"
    :class="{
      [messageStateData && messageStateData[0].type] : messageStateData,
      'is-filled': getValue && getValue.length,
      'focus': isFocus && !errorMessages.length,
      'disabled': disabled,
    }"
    @click="handleClick"
  >
    <UiText
      v-if="label"
      class="input-wrapper__label"
      font="body-text"
      :text="label"
    />

    <div class="input-wrapper__body">
      <slot name="side" :focus="isFocus" />

      <Component
        :is="mask ? 'TheMask' : 'Money'"
        v-if="mask || money"
        ref="input"
        v-model="getValue"
        :mask="mask"
        class="input-wrapper__input"
        :class="{ center : textCenter }"
        :disabled="disabled"
        v-bind="{ ...$attrs, ...money }"
        v-on="c_listeners"
        @focus.native="handleFocus"
        @blur.native="handleBlur"
      />
      <input
        v-else
        ref="input"
        v-model="getValue"
        class="input-wrapper__input"
        :class="{ center : textCenter }"
        :disabled="disabled"
        v-bind="$attrs"
        v-on="c_listeners"
        @focus="handleFocus"
        @blur="handleBlur"
        @paste="handlePaste"
      />

      <slot name="body-right" />

      <SvgIcon
        v-if="statusIcon"
        :name="messageStateData[0].icon"
        class="input-wrapper__status-icon"
        :class="messageStateData[0].type"
      />
      <div class="input-wrapper__state" />
    </div>

    <div
      v-if="messageStateData"
      class="messages-list"
      :class="messageStateData[0].type"
    >
      <slot :name="messageStateData.type">
        <div v-for="statusItem in messageStateData" :key="statusItem.type">
          <UiHint
            v-for="(message, index) in statusItem.messages"
            :key="index"
            :type="statusItem.type"
            :text="message"
          />
        </div>
      </slot>
    </div>
    <slot name="footer" />
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'
import { Money } from 'v-money'
import UiHint from '@/components/ui/UiHint'

export default {
  name: 'BaseInput',
  components: { TheMask, Money, UiHint },
  props: {
    value: { type: [String, Number] },
    disabled: { type: Boolean },
    textCenter: { type: Boolean },
    label: { type: String },
    mask: { type: [String, Array] },
    money: { type: Object },
    errorMessages: { type: Array, default: () => [] },
    warningMessages: { type: Array, default: () => [] },
    infoMessages: { type: Array, default: () => [] },
    successMessages: { type: Array, default: null },
    statusIcon: { type: Boolean },
    focus: { type: Boolean },
    hasError: { type: Boolean },
    isHardValue: { type: Boolean },
  },
  data() {
    return {
      isFocus: false,
    }
  },
  computed: {
    c_listeners() {
      const { input, focus, bluer, ...listeners } = this.$listeners
      return this.isHardValue ? { input, ...listeners } : listeners
    },
    getValue: {
      get() {
        return this.value
      },
      set(v) {
        this.isHardValue ? null : this.$emit('input', v)
      },
    },
    messageStateData() {
      const statuses = []

      if (this.errorMessages.length || this.hasError) {
        statuses.push({
          type: 'error',
          icon: 'input-messages/cross-circle',
          messages: this.errorMessages,
        })
      }

      if (this.warningMessages.length) {
        statuses.push({
          type: 'warning',
          icon: 'input-messages/alert-circle',
          messages: this.warningMessages,
        })
      }

      if (this.infoMessages.length) {
        statuses.push({
          type: 'info',
          icon: 'input-messages/alert-circle',
          messages: this.infoMessages,
        })
      }

      if (this.successMessages) {
        statuses.push({
          type: 'success',
          icon: 'input-messages/check-circle',
          messages: this.successMessages,
        })
      }

      return statuses.length ? statuses : null
    },
  },
  watch: {
    focus() {
      if (this.focus) {
        this.addFocus()
      }
    },
  },
  mounted() {
    if (this.focus) {
      this.addFocus()
    }
  },
  methods: {
    addFocus() {
      this.getInput().focus()
    },
    getInput() {
      return this.$refs.input.$el || this.$refs.input
    },
    handleFocus() {
      this.$emit('focus')
      this.isFocus = true
    },
    handleBlur(e) {
      this.$emit('blur', e?.target?.value)
      this.isFocus = false
    },
    handleClick() {
      this.$emit('click')
      this.addFocus()
    },
    handlePaste(event) {
      console.log(event.clipboardData.getData('text')) 
      this.$emit('paste', event)
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
